export default "__VITE_ASSET__n31LFMSK__"